module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/120-bahamas-69ec0182cc4f50676dc639a453764d10.svg";